import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 19331 27519"
    {...props}
  >
    <path
      d="M913 6946c0-1237 336-2403 1015-3501 672-1097 1662-1972 2968-2632C5661 431 6501 159 7418 0v3941c-230 145-443 318-638 519-711 723-1066 1655-1066 2797 0 1053 362 1934 1091 2632 190 183 394 342 613 477v4611c-373 197-719 452-1038 766-856 843-1281 2023-1281 3532 0 971 203 1820 603 2556 405 736 951 1307 1642 1713l74 41v3933c-1107-172-2106-476-2991-912-1465-716-2569-1705-3311-2961S0 20981 0 19421c0-3330 1573-5613 4725-6850C2182 11386 913 9508 913 6946zM11912 32c513 93 997 218 1451 375 1116 381 2042 913 2790 1586 742 678 1294 1439 1649 2283 362 850 539 1751 539 2708 0 1212-310 2296-938 3247-622 952-1561 1732-2797 2340 1053 407 1928 945 2619 1605 698 666 1224 1434 1573 2302 355 875 533 1846 533 2905 0 1560-381 2974-1135 4243-755 1268-1865 2264-3324 2980-891 436-1878 741-2960 913v-3935l93-53c692-406 1237-983 1631-1725 399-749 596-1599 596-2569 0-964-197-1807-596-2524-394-723-952-1275-1669-1655l-55-29v-4721c191-124 366-264 525-419 342-330 608-717 793-1173 184-451 278-952 278-1497 0-730-164-1389-494-1973-271-488-639-887-1102-1201V32z"
      style={{
        fill: "#2b2a29",
      }}
      className="fill"
    />
  </svg>
)
export default SvgComponent
